export function SayingsSlide(mode) {
	this.cycle = false;
    this.buster = '202608041518';
    this.imageSets = {
        'logos': [
            '/assets/images/promos/2026/logo-1.jpg?b=' + this.buster,
            '/assets/images/promos/2026/logo-2.jpg?b=' + this.buster,
            '/assets/images/promos/2026/logo-3.jpg?b=' + this.buster,
        ],
        'quotes': [
            '/assets/images/promos/2026/phrase-2.jpg?b=' + this.buster,
            '/assets/images/promos/2026/phrase-3.jpg?b=' + this.buster,
            '/assets/images/promos/2026/phrase-4.jpg?b=' + this.buster,
            '/assets/images/promos/2026/phrase-5.jpg?b=' + this.buster,
            '/assets/images/promos/2026/quote-1.jpg?b=' + this.buster,
            '/assets/images/promos/2026/quote-2.jpg?b=' + this.buster,
            '/assets/images/promos/2026/quote-5.jpg?b=' + this.buster,
            '/assets/images/promos/2026/quote-6.jpg?b=' + this.buster,
        ],
        'sponsors': [
            // The repeated CR and LL slides here seemed a bit much.
            // '/assets/images/promos/2024/sponsor-click-rain-1.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-lemonly-1.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-book-your-billboard.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-first-dakota.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-loft-advisors.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-paj.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-american-family-insurance.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-high-tone-hearing.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-bierschbach.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-dacotah-bank.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-julie-roth.jpg?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-isg.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-diamond-mowers.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-neighborhood-dental.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-great-shots.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-royzzz.jpg?b=' + this.buster,
            // '/assets/images/promos/2024/sponsor-american-family-insurance.jpg?b=' + this.buster,
        ],
        'concertLight': [
            '/assets/images/promos/2026/concert-light-1.jpg?b=' + this.buster,
        ],
        'concertDark': [
            '/assets/images/promos/2026/concert-dark-1.jpg?b=' + this.buster,
        ],
        'cr-sponsors': [
            '/assets/images/promos/2026/sponsor-click-rain-2.gif?b=' + this.buster,
            '/assets/images/promos/2026/sponsor-lemonly-2.gif?b=' + this.buster,
        ],
        'tys': [
            '/assets/images/promos/2026/ty-1.jpg?b=' + this.buster,
            '/assets/images/promos/2026/ty-2.jpg?b=' + this.buster,
        ]
    };
    this.images = this.imageSets[mode];
}
function getRandom(array) {
    var randomIndex = Math.round(Math.random() * ((array.length - 1) - 0) + 0);
    console.log(randomIndex);
    return array[randomIndex];
}
function getRandomNumber(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
SayingsSlide.prototype.elementCreated = function(element) {
	this.element = element;
	this.parent = element.querySelector('.slide-content');
}
SayingsSlide.prototype.show = function() {
    while (this.parent.childNodes.length > 0) {
		this.parent.removeChild(this.parent.childNodes[0]);
	}
    var self = this;
    var sayingImage = document.createElement('img');
    var imageSrc = getRandom(this.images);
    var imageSrcParts = imageSrc.split('=');
    var fileType = imageSrcParts[0].split('.').pop().split('?')[0];
    var buster = imageSrcParts[1].split('-')[0];
    var newBuster = fileType == 'gif' ? buster + '-' + getRandomNumber(0, 999999) : buster;
    sayingImage.src = imageSrcParts[0] + '=' + newBuster;
    this.parent.innerHtml = '';
    this.parent.appendChild(sayingImage);
}
